import { useSelector } from "react-redux";
import { getOnlineStatus } from "../internetConnectionSelectors";
import { getWebsocketReadyStateConnecting } from "../../../providers/WebSocketProvider/websocketSelectors";
import { TDisconnectedStatus } from "../internetConnection.t";
import { CONNECTION_STATUS_NAMES } from "../internetConnectionConstants";

export const useDisconnectedStatus = (): TDisconnectedStatus => {
    const isOnline = useSelector(getOnlineStatus);
    const websocketState = useSelector((getWebsocketReadyStateConnecting));

    if (isOnline === false) {
        return CONNECTION_STATUS_NAMES.DISCONNECTED;
    }

    if (websocketState === WebSocket.OPEN) {
        return CONNECTION_STATUS_NAMES.CONNECTED;
    }

    return CONNECTION_STATUS_NAMES.CONNECTING;
};